import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ClrIconModule} from "@clr/angular";
import {FlowRessourceObject} from "@app/netscope/model/data-models";
import {AppsGroupFlowsStatus, FlowViewHost} from "@app/netscope/netscope-common-flowview/flowview-host";

/**
 * Box of an apps group included in another one, drawn inside the box of the group including it. It is closed
 * by default, standing for all of its members at once, and shows them inside of it once opened, with the groups
 * it includes in turn as boxes of their own. Its cog opens the settings of the group, in the file holding it.
 */
@Component({
  selector: 'app-included-apps-group-element',
  imports: [ClrIconModule],
  templateUrl: './included-apps-group-element.component.html',
  styleUrl: './included-apps-group-element.component.css'
})
export class IncludedAppsGroupElementComponent {
  @Input() appGroup: FlowRessourceObject;
  @Input() flowComponent: FlowViewHost;

  @Output() descriptionChanged = new EventEmitter<string>();

  get expanded(): boolean {
    return this.appGroup.inclusion?.expanded ?? false;
  }

  // Whether the box exchanged flows, as the renderer found while drawing it
  get flowsStatus(): AppsGroupFlowsStatus {
    return this.flowComponent.appsGroupsFlowsStatus?.get(this.appGroup.uuid) ?? "flows";
  }

  get selected(): boolean {
    let inclusion = this.appGroup.inclusion;
    return inclusion != undefined
      && this.flowComponent.selectedAppsGroupName == inclusion.includingAppsGroupName
      && this.flowComponent.selectedIncludedAppsGroupKey == inclusion.key;
  }

  // What a closed box holds, as it shows none of it
  get foldedSummary(): string {
    let membersCount = this.appGroup.inclusion?.memberUuids.length ?? 0;
    let groupsCount = this.appGroup.inclusion?.includedCount ?? 0;
    let parts = [membersCount == 1 ? "1 member" : `${membersCount} members`];
    if (groupsCount > 0) {
      parts.push(groupsCount == 1 ? "1 group inside" : `${groupsCount} groups inside`);
    }
    return parts.join(" · ");
  }

  showSettings = (event: Event) => {
    event.stopPropagation();
    this.flowComponent.showIncludedAppsGroupSettings({name: this.appGroup.name, file: this.appGroup.inclusion.file});
  }

  toggle = (event: Event) => {
    // The box sits inside the paper, which would otherwise take the click for the start of a drag
    event.stopPropagation();
    this.flowComponent.toggleIncludedAppsGroup(this.appGroup.inclusion);
  }
}
